import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { target: "_blank" }
const _hoisted_7 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = {
  class: "tab-content",
  style: {"height":"400px"}
}
const _hoisted_11 = { class: "dropdown d-inline-block" }
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = { class: "px-2 py-1" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { style: {"max-height":"200px","overflow-y":"auto"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "table table-hover mt-3"
}
const _hoisted_18 = { class: "align-middle" }
const _hoisted_19 = { target: "_blank" }
const _hoisted_20 = { class: "align-middle" }
const _hoisted_21 = { class: "align-middle" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "dropdown d-inline-block" }
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = { class: "px-2 py-1" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { style: {"max-height":"200px","overflow-y":"auto"} }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "table table-hover mt-3"
}
const _hoisted_30 = { class: "align-middle" }
const _hoisted_31 = { target: "_blank" }
const _hoisted_32 = { class: "align-middle" }
const _hoisted_33 = ["onClick"]

import { ref, computed, toRef } from 'vue'
    import { useRoute } from 'vue-router'

    import { strCompareLowerCase } from '@common/Common'
    import { dynamicUiRoutes } from '../../../App/Web/Scripts/dynamicUiRoutes'

    import type { AlternativeReadModel } from '@Alternatives/Alternatives/Domain/readmodels'
    import type { AlternativeRelationshipsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeRelationshipsDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AlternativeRelationshipsDialog',
  props: {
    viewModel: {}
  },
  emits: ["load-alternatives", "unlink-dependent", "unlink-foundation", "link-dependent", "link-foundation"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- routing ----------------

    const route = useRoute()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const searchOtherPhrase = ref<string | null>(null)
    const tab = ref<'Foundations' | 'Dependents'>('Foundations')

    // ---------------- derived (VM passthrough) ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const workspaceId = computed(() => vm.value.workspaceId)
    const tchProjectId = computed(() => vm.value.tchProjectId)

    const alternativeLabel = computed(() => vm.value.alternativeLabel)
    const alternativesLabel = computed(() => vm.value.alternativesLabel)

    const alternativeId = computed(() => vm.value.alternativeId)
    const alternativeName = computed(() => vm.value.alternativeName)
    const alternativeStatusId = computed(() => vm.value.alternativeStatusId)
    const alternativeStatusName = computed(() => vm.value.alternativeStatusName)

    const dependents = computed(() => vm.value.dependents)
    const foundations = computed(() => vm.value.foundations)

    // ---------------- helpers ----------------

    function url_AlternativeDashboardPage(alternativeId: string): string
    {
        return dynamicUiRoutes.Alternatives_AlternativeDashboardPage(
            route,
            workspaceId.value,
            tchProjectId.value,
            alternativeId
        )
    }

    // ---------------- candidates ----------------

    const dependentsCandidatesView = computed<AlternativeReadModel[]>(() =>
    {
        const currIds = new Set([
            ...dependents.value.map(a => a.Id),
            alternativeId.value
        ])

        let view = vm.value.allAlternatives?.filter(a => !currIds.has(a.Id)) ?? []

        if (searchOtherPhrase.value)
        {
            const phrase = searchOtherPhrase.value.toLowerCase()
            view = view.filter(a =>
                a.Name && a.Name.toLowerCase().includes(phrase)
            )
        }

        return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name))
    })

    const foundationsCandidatesView = computed<AlternativeReadModel[]>(() =>
    {
        const currIds = new Set([
            ...foundations.value.map(a => a.Id),
            alternativeId.value
        ])

        let view = vm.value.allAlternatives?.filter(a => !currIds.has(a.Id)) ?? []

        if (searchOtherPhrase.value)
        {
            const phrase = searchOtherPhrase.value.toLowerCase()
            view = view.filter(a =>
                a.Name && a.Name.toLowerCase().includes(phrase)
            )
        }

        return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name))
    })

    // ---------------- actions ----------------

    function loadAlternatives()
    {
        if (vm.value.allAlternatives.length === 0)
        {
            emit('load-alternatives')
        }
    }

    function handleUnlinkDependent(d: AlternativeReadModel)
    {
        emit('unlink-dependent', d.Id)
    }

    function handleUnlinkFoundation(f: AlternativeReadModel)
    {
        emit('unlink-foundation', f.Id)
    }

    function handleLinkFoundation(f: AlternativeReadModel)
    {
        emit('link-foundation', f.Id)
    }

    function handleLinkDependent(d: AlternativeReadModel)
    {
        emit('link-dependent', d.Id)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "modal-title" }, "Dependencies", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(alternativeLabel.value) + ": ", 1 /* TEXT */),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [
                    _createTextVNode(_toDisplayString(alternativeName.value), 1 /* TEXT */)
                  ])), [
                    [_directive_sanitizedHref, url_AlternativeDashboardPage(alternativeId.value)]
                  ])
                ]),
                _createElementVNode("p", null, "Status: " + _toDisplayString(alternativeStatusName.value), 1 /* TEXT */),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("ul", _hoisted_7, [
                  _createElementVNode("li", _hoisted_8, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", { active: tab.value === 'Foundations' }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'Foundations'))
                    }, " Foundations (" + _toDisplayString(foundations.value.length) + ") ", 3 /* TEXT, CLASS */)
                  ]),
                  _createElementVNode("li", _hoisted_9, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", { active: tab.value === 'Dependents' }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'Dependents'))
                    }, " Dependents (" + _toDisplayString(dependents.value.length) + ") ", 3 /* TEXT, CLASS */)
                  ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", { active: tab.value === 'Foundations' }])
                  }, [
                    _createElementVNode("div", null, [
                      _createTextVNode(" This " + _toDisplayString(alternativeLabel.value.toLowerCase()) + " is dependent on " + _toDisplayString(foundations.value.length) + " other " + _toDisplayString(alternativesLabel.value.toLowerCase()) + " ", 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("a", {
                          class: "text-primary",
                          "data-toggle": "dropdown",
                          onClick: loadAlternatives
                        }, "Add a foundation"),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("form", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                placeholder: "Search...",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchOtherPhrase).value = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, searchOtherPhrase.value]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(foundationsCandidatesView.value, (a) => {
                              return (_openBlock(), _createElementBlock("a", {
                                class: "dropdown-item",
                                key: a.Id,
                                onClick: ($event: any) => (handleLinkFoundation(a))
                              }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_16))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ]),
                    (foundations.value.length > 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(alternativeLabel.value), 1 /* TEXT */),
                              _cache[5] || (_cache[5] = _createElementVNode("th", null, "Status", -1 /* CACHED */)),
                              _cache[6] || (_cache[6] = _createElementVNode("th", { style: {"width":"100px"} }, null, -1 /* CACHED */))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(foundations.value, (f) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: f.Id,
                                class: _normalizeClass({'table-warning': (f.StatusId !== alternativeStatusId.value) })
                              }, [
                                _createElementVNode("td", _hoisted_18, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, [
                                    _createTextVNode(_toDisplayString(f.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_AlternativeDashboardPage(f.Id)]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(f.StatusName), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_21, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-secondary",
                                    onClick: ($event: any) => (handleUnlinkFoundation(f)),
                                    title: "Remove dependency"
                                  }, [...(_cache[7] || (_cache[7] = [
                                    _createElementVNode("i", {
                                      class: "fa fa-chain-broken",
                                      "aria-hidden": "true"
                                    }, null, -1 /* CACHED */)
                                  ]))], 8 /* PROPS */, _hoisted_22)
                                ])
                              ], 2 /* CLASS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", { active: tab.value === 'Dependents' }])
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, " This " + _toDisplayString(alternativeLabel.value.toLowerCase()) + " is a foundation for " + _toDisplayString(dependents.value.length) + " other " + _toDisplayString(alternativesLabel.value.toLowerCase()) + ". ", 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("a", {
                          class: "text-primary",
                          "data-toggle": "dropdown",
                          onClick: loadAlternatives
                        }, "Add a dependent"),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("form", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                placeholder: "Search...",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchOtherPhrase).value = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, searchOtherPhrase.value]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dependentsCandidatesView.value, (a) => {
                              return (_openBlock(), _createElementBlock("a", {
                                class: "dropdown-item",
                                key: a.Id,
                                onClick: ($event: any) => (handleLinkDependent(a))
                              }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_28))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ]),
                    (dependents.value.length > 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_29, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(alternativeLabel.value), 1 /* TEXT */),
                              _cache[8] || (_cache[8] = _createElementVNode("th", null, "Status", -1 /* CACHED */)),
                              _cache[9] || (_cache[9] = _createElementVNode("th", { style: {"width":"100px"} }, null, -1 /* CACHED */))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dependents.value, (d) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: d.Id,
                                class: _normalizeClass({'table-warning': (d.StatusId !== alternativeStatusId.value) })
                              }, [
                                _createElementVNode("td", _hoisted_30, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_31, [
                                    _createTextVNode(_toDisplayString(d.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_AlternativeDashboardPage(d.Id)]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_32, _toDisplayString(d.StatusName), 1 /* TEXT */),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-secondary",
                                    onClick: ($event: any) => (handleUnlinkDependent(d)),
                                    title: "Remove dependency"
                                  }, [...(_cache[10] || (_cache[10] = [
                                    _createElementVNode("i", {
                                      class: "fa fa-chain-broken",
                                      "aria-hidden": "true"
                                    }, null, -1 /* CACHED */)
                                  ]))], 8 /* PROPS */, _hoisted_33)
                                ])
                              ], 2 /* CLASS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})